import { defineComponent as _defineComponent } from 'vue';
import { toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveDirective as _resolveDirective, openBlock as _openBlock, createElementBlock as _createElementBlock, withDirectives as _withDirectives, createElementVNode as _createElementVNode, createVNode as _createVNode, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, unref as _unref, resolveComponent as _resolveComponent, withCtx as _withCtx, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
const _withScopeId = n => (_pushScopeId("data-v-a3ef4692"), n = n(), _popScopeId(), n);
const _hoisted_1 = { class: "sms-campaigns-messages" };
const _hoisted_2 = { class: "sms-campaigns-messages__title" };
const _hoisted_3 = { class: "required" };
const _hoisted_4 = {
    key: 0,
    class: "sms-campaigns-messages__empty"
};
const _hoisted_5 = ["innerHTML"];
const _hoisted_6 = { key: 1 };
const _hoisted_7 = { key: 0 };
const _hoisted_8 = { key: 1 };
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ _createElementVNode("span", { class: "sms-campaigns-messages__dropdown" }, [
    /*#__PURE__*/ _createElementVNode("i", { class: "icon icon-menu-14px" })
], -1));
import { computed } from 'vue';
import { useStore } from 'vuex';
import { humanizeDate } from '@/utilities/formatters';
import bus from '@/helpers/events/bus';
import ActionsNewMessageModal from '@/components/oto/actions/modals/ActionsNewMessageModal.vue';
export default /*#__PURE__*/ _defineComponent({
    __name: 'SMSCampaignsMessages',
    setup(__props) {
        const store = useStore();
        const columns = [
            { key: 'message', label: 'sms-campaigns.messages.columns.message' },
            { key: 'createdAt', label: 'sms-campaigns.messages.columns.createdAt' },
            { key: 'actions', label: '' },
        ];
        const message = computed(() => store.getters['smsCampaigns/getMessage']);
        const isMessageEmpty = computed(() => store.getters['smsCampaigns/isMessageEmpty']);
        const addMessage = () => {
            bus.$emit('open-actions-new-message-modal');
        };
        const editMessage = (message) => {
            bus.$emit('open-actions-new-message-modal-edit-sms', message);
        };
        const deleteMessage = () => {
            store.commit('smsCampaigns/DELETE_MESSAGE');
        };
        const getWidth = (column) => {
            const width = {
                message: 220,
                actions: 20,
            };
            const hasWidth = Object.keys(width).includes(column);
            return hasWidth ? width[column] : 100;
        };
        return (_ctx, _cache) => {
            const _component_el_dropdown_item = _resolveComponent("el-dropdown-item");
            const _component_el_dropdown_menu = _resolveComponent("el-dropdown-menu");
            const _component_el_dropdown = _resolveComponent("el-dropdown");
            const _component_el_table_column = _resolveComponent("el-table-column");
            const _component_el_table = _resolveComponent("el-table");
            const _directive_tooltip = _resolveDirective("tooltip");
            return (_openBlock(), _createElementBlock("div", _hoisted_1, [
                _createElementVNode("strong", _hoisted_2, [
                    _createTextVNode(_toDisplayString(_ctx.$t('sms-campaigns.messages.title')) + " ", 1),
                    _withDirectives((_openBlock(), _createElementBlock("span", _hoisted_3, [
                        _createTextVNode("*")
                    ])), [
                        [
                            _directive_tooltip,
                            {
                                theme: 'error',
                                html: true,
                                autoHide: false,
                                distance: 14,
                                content: _ctx.$t('campaigns.required-section'),
                                shown: isMessageEmpty.value,
                            },
                            void 0,
                            { right: true }
                        ]
                    ])
                ]),
                _createVNode(ActionsNewMessageModal, {
                    type: "sms",
                    page: "sms"
                }),
                (!message.value.length)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
                        _createElementVNode("span", {
                            innerHTML: _ctx.$t('sms-campaigns.messages.empty')
                        }, null, 8, _hoisted_5),
                        _createElementVNode("strong", { onClick: addMessage }, _toDisplayString(_ctx.$t('sms-campaigns.messages.add')), 1)
                    ]))
                    : (_openBlock(), _createElementBlock("div", _hoisted_6, [
                        _createVNode(_component_el_table, {
                            data: message.value,
                            class: "sms-campaigns-messages__table"
                        }, {
                            default: _withCtx(() => [
                                (_openBlock(), _createElementBlock(_Fragment, null, _renderList(columns, (column, index) => {
                                    return _createVNode(_component_el_table_column, {
                                        key: index,
                                        prop: column.key,
                                        label: _ctx.$t(column.label),
                                        "min-width": getWidth(column.key)
                                    }, {
                                        default: _withCtx((scope) => [
                                            (column.key === 'createdAt')
                                                ? (_openBlock(), _createElementBlock("span", _hoisted_7, _toDisplayString(_unref(humanizeDate)(scope.row.createdAt)), 1))
                                                : _createCommentVNode("", true),
                                            (column.key === 'actions')
                                                ? (_openBlock(), _createElementBlock("div", _hoisted_8, [
                                                    _createVNode(_component_el_dropdown, { trigger: "click" }, {
                                                        dropdown: _withCtx(() => [
                                                            _createVNode(_component_el_dropdown_menu, null, {
                                                                default: _withCtx(() => [
                                                                    _createVNode(_component_el_dropdown_item, {
                                                                        onClick: ($event) => (editMessage(scope.row.message))
                                                                    }, {
                                                                        default: _withCtx(() => [
                                                                            _createTextVNode(_toDisplayString(_ctx.$t('edit')), 1)
                                                                        ]),
                                                                        _: 2
                                                                    }, 1032, ["onClick"]),
                                                                    _createVNode(_component_el_dropdown_item, {
                                                                        onClick: _cache[0] || (_cache[0] = ($event) => (deleteMessage()))
                                                                    }, {
                                                                        default: _withCtx(() => [
                                                                            _createTextVNode(_toDisplayString(_ctx.$t('delete')), 1)
                                                                        ]),
                                                                        _: 1
                                                                    })
                                                                ]),
                                                                _: 2
                                                            }, 1024)
                                                        ]),
                                                        default: _withCtx(() => [
                                                            _hoisted_9
                                                        ]),
                                                        _: 2
                                                    }, 1024)
                                                ]))
                                                : _createCommentVNode("", true)
                                        ]),
                                        _: 2
                                    }, 1032, ["prop", "label", "min-width"]);
                                }), 64))
                            ]),
                            _: 1
                        }, 8, ["data"])
                    ]))
            ]));
        };
    }
});
